import * as AlertDialog from '@givebutter/primitives/alert-dialog';
import { DropdownMenuItem } from '@givebutter/primitives/dropdown-menu';
import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCurrentNode } from 'assets/js/pages/engage/workflows/hooks/useCurrentNode';
import { useDeleteNodeHandler } from 'assets/js/pages/engage/workflows/hooks/useDeleteNodeHandler';
import { WorkflowUtilityNodeTypeEnum } from 'constants/workflows';

const DeleteCanvasNodeMenuItem = () => {
    const currentNode = useCurrentNode();
    const isBranchNode = currentNode?.type === WorkflowUtilityNodeTypeEnum.BRANCH;
    const handleOnDelete = useDeleteNodeHandler({ currentNode });

    return (
        <AlertDialog.Root type="error">
            <AlertDialog.Trigger asChild>
                <DropdownMenuItem
                    onSelect={e => e.preventDefault()}
                    onClick={e => e.stopPropagation()}
                    className="flex w-full items-center gap-2 text-red-500 focus-visible:before:border-0"
                >
                    <FontAwesomeIcon icon={faTrash} />
                    Delete
                </DropdownMenuItem>
            </AlertDialog.Trigger>
            <AlertDialog.Portal>
                <AlertDialog.Overlay />
                <AlertDialog.Content onClick={e => e.stopPropagation()}>
                    <AlertDialog.Header>
                        <AlertDialog.Icon />
                        <AlertDialog.Close />
                    </AlertDialog.Header>
                    <AlertDialog.Body>
                        <AlertDialog.Title>
                            {isBranchNode ? 'Delete branch step?' : 'Delete step?'}
                        </AlertDialog.Title>
                        <AlertDialog.Description>
                            {isBranchNode
                                ? 'Are you sure you want to delete this branch step? All child steps will also be deleted.'
                                : 'Are you sure you want to delete this step? You’ll lose the action’s saved settings.'}
                        </AlertDialog.Description>
                    </AlertDialog.Body>
                    <AlertDialog.Footer>
                        <AlertDialog.Cancel>Cancel</AlertDialog.Cancel>
                        <AlertDialog.Action onClick={handleOnDelete}>Delete</AlertDialog.Action>
                    </AlertDialog.Footer>
                </AlertDialog.Content>
            </AlertDialog.Portal>
        </AlertDialog.Root>
    );
};

export { DeleteCanvasNodeMenuItem };
